import $ from 'jquery';
import Selectize from 'selectize';

/**
 * Escapes a string for use within HTML.
 *
 * @param {string} str
 * @return {string}
 */
const escapeHtml = function (str) {
    return (`${str}`)
        .replace(/&/g, '&amp;')
        .replace(/</g, '&lt;')
        .replace(/>/g, '&gt;')
        .replace(/"/g, '&quot;');
};

Selectize.define('multiple_select_remove_button', function (options) {
    options = $.extend({
        label: '&times;',
        title: 'Remove',
        className: 'remove',
        append: true
    }, options);

    let singleClose = function (thisRef, opts) {

        opts.className = 'remove-single';

        let self = thisRef;
        let html = `<a href="javascript:void(0)" class="${ opts.className }" tabindex="-1" title="${ escapeHtml(opts.title) }">${ opts.label }</a>`;

        /**
         * Appends an element as a child (with raw HTML).
         *
         * @param {string} htmlContainer
         * @param {string} htmlElement
         * @return {string}
         */
        let append = function (htmlContainer, htmlElement) {
            return htmlContainer + htmlElement;
        };

        thisRef.setup = (function () {
            let original = self.setup;
            return function () {
                // override the item rendering method to add the button to each
                if (opts.append) {
                    let renderItem = self.settings.render.item;
                    self.settings.render.item = function () {
                        return append(renderItem.apply(thisRef, arguments), html);
                    };
                }

                original.apply(thisRef, arguments);

                // add event listener
                thisRef.$control.on('click', `.${ opts.className}`, (evt) => {
                    evt.preventDefault();
                    if (self.isLocked) {
                        return;
                    }

                    let $item = $(evt.currentTarget).parent();

                    if (!self.settings.hideSelected) {
                        self.$dropdown
                            .find(`[data-value="${$item.data('value')}"]`)
                            .removeClass('selected');
                    }

                    self.clear();
                });

            };
        })();
    };

    let multiClose = function (thisRef, opts) {

        let self = thisRef;
        let html = `<a href="javascript:void(0)" class="${ opts.className }" tabindex="-1" title="${ escapeHtml(opts.title) }">${ opts.label }</a>`;

        /**
         * Appends an element as a child (with raw HTML).
         *
         * @param {string} htmlContainer
         * @param {string} htmlElement
         * @return {string}
         */
        let append = function (htmlContainer, htmlElement) {
            let pos = htmlContainer.search(/(<\/[^>]+>\s*)$/);
            return htmlContainer.substring(0, pos) + htmlElement + htmlContainer.substring(pos);
        };

        thisRef.setup = (function () {
            let original = self.setup;
            return function () {
                // override the item rendering method to add the button to each
                if (opts.append) {
                    let renderItem = self.settings.render.item;
                    self.settings.render.item = function () {
                        return append(renderItem.apply(thisRef, arguments), html);
                    };
                }

                original.apply(thisRef, arguments);

                // add event listener
                thisRef.$control.on('click', `.${ opts.className}`, (evt) => {
                    evt.preventDefault();
                    if (self.isLocked) {
                        return;
                    }

                    let $item = $(evt.currentTarget).parent();

                    if (!self.settings.hideSelected) {
                        self.$dropdown
                            .find(`[data-value="${$item.data('value')}"]`)
                            .removeClass('selected');
                    }

                    self.setActiveItem($item);
                    if (self.deleteSelection()) {
                        self.setCaret(self.items.length);
                    }
                });

            };
        })();
    };

    if (this.settings.mode === 'single') {
        singleClose(this, options);
        return;
    } else {
        multiClose(this, options);
    }
});
